import styled from "styled-components"
import Breakpoints from "../../components/shared/breakpoints"
import { T } from "./text"

const AccentBox = styled.div`
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.07);
  border-radius: 2px;
  border-top: 4px solid ${(props) => props.accentColor ?? "var(--burnt-orange)"};
`

export const TypeCard = styled(AccentBox)`
  display: flex;
  flex-direction: column;

  padding: 32px 18px;
  text-align: center;
  align-items: center;

  @media (min-width: ${Breakpoints.md}) {
    padding: 48px 20%;
  }

  @media (min-width: ${Breakpoints.lg}) {
    padding: 48px;
  }
`

TypeCard.Logo = styled.img``

TypeCard.Title = styled.h3`
  ${T.md.h3`500`}
  color: var(--slate);
  margin-top: 24px;

  @media (min-width: ${Breakpoints.md}) {
    ${T.sm.h3`500`}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.md.h3`500`}
    flex-grow: 1;
  }
`

TypeCard.Description = styled.p`
  ${T.md.body`400`}
  margin-top: 24px;
  color: var(--body-text-grey);

  @media (min-width: ${Breakpoints.md}) {
    margin-top: 20px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body`400`};
    font-size: 16px;
    margin-top: 18px;
  }
`

export const TierCard = styled(AccentBox)`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  padding: 28px 18px 32px;

  @media (min-width: ${Breakpoints.md}) {
    padding: 28px 48px 32px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    padding: 28px 32px 32px;
  }
`

TierCard.Title = styled.h3`
  ${T.md.h3`500`}
  color: var(--tricorn-black);

  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.h3`500`}
  }
`

TierCard.Description = styled.p`
  ${T.md.body`400`}
  margin-top: 16px;
  color: var(--body-text-grey);
  @media (min-width: ${Breakpoints.md}) {
    margin-top: 24px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body`400`};
    font-size: 16px;
    margin-top: 16px;
  }
`

TierCard.Subtitle = styled.h4`
  ${T.md.h4`400`}
  margin-top: 32px;
  color: var(--tricorn-black);
`

TierCard.List = styled.ul`
  list-style-type: none;
  margin-top: 16px;
`

TierCard.ListItem = styled.li`
  ${T.md.body`400`}
  color: var(--body-text-grey);
  margin-top: 8px;
  @media (min-width: ${Breakpoints.lg}) {
    ${T.lg.body`400`};
    font-size: 16px;
  }
`

TierCard.AccentListItem = styled(TierCard.ListItem)`
  & {
    font-weight: 500;
  }
  display: inline-flex;
  align-items: center;
  color: ${(props) => props.color ?? "inherit"};

  & > svg {
    margin-right: 12px;
  }
`
